import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface SectionLabelProps {
    index?: string
    children: ReactNode
    className?: string
}

// The mono eyebrow used across the site: "(03) Diagnosis".
const SectionLabel: FC<SectionLabelProps> = ({ index, children, className }): ReactNode => {
    return (
        <p className={cn('type-label flex items-center gap-3 text-quiet', className)}>
            {index && (
                <span className='text-fore'>
                    ({index})
                </span>
            )}

            <span>
                {children}
            </span>
        </p>
    )
}

export default SectionLabel
